import { dialogClasses, listItemIconClasses, Theme } from '@mui/material'
import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const searchListStyles: moduleStyleType = {
    divider: {
        mt: 3,
    },
    icon: {
        color: 'text.secondary',
    },
    esc: {
        px: 1,
    },
    keyNav: {
        mt: 3,
    },
}
export const SpotlightStyles: moduleStyleType = {
    dialog: {
        [`& .${dialogClasses.container}`]: {
            alignItems: 'flex-start',
        },
    },
}

export const QuickLinksStyles = {
    header: {
        color: 'text.primary',
        fontWeight: 600,
    },
    listItem: {
        borderRadius: '6px',
        gap: 1,
        '&:hover': {
            backgroundColor: 'primary.extraLight',
            color: 'primary.dark',
            [`& .${listItemIconClasses.root}`]: {
                color: 'primary.dark',
            },
        },
        '&:focus-visible': {
            boxShadow: (theme: Theme): string => `inset 0 0 0 2px ${theme.palette.primary.main}`,
            backgroundColor: 'common.white',
            color: 'text.primary',
        },
    },
    section: {
        minWidth: '200px',
        maxWidth: '33%',
        py: 1,
    },
    placeholder: {
        color: 'text.secondary',
        px: 4,
        py: 1,
    },
}
